import { STATUSES } from './constants.esm.js';
import logger from '@agoras/logger';
import { jwtDecode } from 'jwt-decode';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var BearerType = {
    SPZA: 'spza',
    REVIEWS: 'pifd',
    COMMERCE: 'commerce',
    JARVIS: 'jarvis',
    ARM: 'arm',
    GRAPH: 'graph',
    LEADS: 'marketplaceLeads',
    AGREEMENT: 'agreement'
};
var isBearerType = function(type) {
    return Object.values(BearerType).some(function(key) {
        return key === type;
    });
};
var AuthController = /*#__PURE__*/ function() {
    function AuthController(getAccessTokenCB) {
        _class_call_check(this, AuthController);
        _define_property(this, "accessTokens", {});
        _define_property(this, "getAccessTokenCallback", void 0);
        _define_property(this, "activeRequestTokenPromise", null);
        var _this = this;
        _define_property(this, "getActiveRequestTokenPromise", /*#__PURE__*/ _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                if (_this.activeRequestTokenPromise) {
                    return [
                        2,
                        _this.activeRequestTokenPromise
                    ];
                }
                _this.activeRequestTokenPromise = _this.getAccessTokenCallback().then(function(tokens) {
                    _this.accessTokens = tokens;
                    _this.activeRequestTokenPromise = null;
                    return tokens;
                });
                return [
                    2,
                    _this.activeRequestTokenPromise
                ];
            });
        }));
        var _this1 = this;
        _define_property(this, "getAccessTokenByCB", function() {
            var _ref = _async_to_generator(function(tokenType) {
                return _ts_generator(this, function(_state) {
                    logger.debug(JSON.stringify({
                        status: STATUSES.authProviderExchange.AUTH_PROVIDER_GET_ACCESS_TOKEN_START,
                        tokenType: tokenType
                    }));
                    try {
                        return [
                            2,
                            _this1.getActiveRequestTokenPromise()
                        ];
                    } catch (e) {
                        logger.error(JSON.stringify({
                            status: STATUSES.authProviderExchange.AUTH_PROVIDER_GET_ACCESS_TOKEN_ERROR,
                            error: e
                        }));
                    }
                    logger.debug(JSON.stringify({
                        status: STATUSES.authProviderExchange.AUTH_PROVIDER_GET_ACCESS_TOKEN_END
                    }));
                    return [
                        2
                    ];
                });
            });
            return function(tokenType) {
                return _ref.apply(this, arguments);
            };
        }());
        this.getAccessTokenCallback = getAccessTokenCB;
    }
    _create_class(AuthController, [
        {
            key: "isTokenExpired",
            value: function isTokenExpired(token) {
                if (!token) {
                    return true;
                }
                var tokenPayload = jwtDecode(token);
                if (!tokenPayload || (typeof tokenPayload === "undefined" ? "undefined" : _type_of(tokenPayload)) != 'object' || typeof tokenPayload.exp != 'number') {
                    return true;
                }
                var expiration = new Date(tokenPayload.exp * 1000).getTime(); // Note that MSAL token is in unix timestamp and needs to be converted to JS Date to check if it's expired
                var now = new Date().getTime();
                return expiration < now;
            }
        },
        {
            key: "getAccessToken",
            value: function getAccessToken(param) {
                var bearerType = param.bearerType;
                var _this = this;
                return _async_to_generator(function() {
                    var currentToken, _this_accessTokens_bearerType;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!bearerType) {
                                    return [
                                        2,
                                        null
                                    ];
                                }
                                currentToken = _this.accessTokens[bearerType];
                                if (!(!currentToken || _this.isTokenExpired(currentToken))) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    _this.getAccessTokenByCB(bearerType)
                                ];
                            case 1:
                                _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    (_this_accessTokens_bearerType = _this.accessTokens[bearerType]) !== null && _this_accessTokens_bearerType !== void 0 ? _this_accessTokens_bearerType : null
                                ];
                        }
                    });
                })();
            }
        }
    ], [
        {
            key: "getInstance",
            value: function getInstance(getAccessTokenCB) {
                if (!AuthController.instance) {
                    AuthController.instance = new AuthController(getAccessTokenCB);
                }
                return AuthController.instance;
            }
        }
    ]);
    return AuthController;
}();
_define_property(AuthController, "instance", void 0);

export { AuthController, BearerType, isBearerType };
